define('flight-components/CategoryList',[
  'App',
  'flight/lib/component',
  'flight-components/GeoSearch',
  'flight-components/mixins/withModal'
],
function (App, defineComponent, GeoSearch, withModal) {

  var CategoryList = function CategoryList() {

    this.defaultAttrs({
      geoToggleSelector: '[data-click="setUserLocation"]'
    });

    this.showCategoryList = function(ev, data) {
      this.activateModal({
        content: '#category-list',
        attr: {
          id: 'modal__category-list'
        },
        data: data
      });
    };

    this.modalWasActivated = function(ev, data) {
      
    };

    this.after('killModal', function() {
      
    });

    this.after('initialize', function () {
      this.on('ui-needs-category-list', this.showCategoryList);
      this.on('uiModalActivated', this.modalWasActivated);
    });
  };

  return defineComponent(CategoryList, withModal);

});

